import { useState, useEffect } from 'react';
import { isMobile } from '../../../../utils/utils';
import { useDispatch, useSelector } from 'react-redux';
import { sendSCEvent } from '../../../../utils/SCEvent';
import { useRouter } from 'next/router';
import { agregarProducto as agregarProductoCarrito } from '../../../../redux/carrito/carritoSlice';
import { agregarProducto as agregarProductoMayorista } from '../../../../redux/carritoMayorista/carritoMayoristaSlice';
import { precioConDescuentoMayorista } from '../../../../utils/mayorista';
import { Producto } from '../../../../models/Producto';

type ItemCarrito = { cantidad: number; producto: { id: number } };

const useHook = ({ producto }: { producto?: Producto }) => {

  const Router = useRouter();
  const dispatch = useDispatch();

  const carrito = useSelector((state: { carrito: { productos: ItemCarrito[] } }) => state.carrito.productos);
  const carritoMayorista = useSelector((state: { carritoMayorista: { productos: ItemCarrito[] } }) => state.carritoMayorista.productos);
  const [mobile, setMobile] = useState(true);
  const [showCartButton, setShowCartButton] = useState(false);
  const [esMayorista, setIsMayorista] = useState(false);
  const [cantidadEnCarrito, setCantidadEnCarrito] = useState(0);

  async function sendEventToSC() {
    sendSCEvent({
      type: 'impression',
      element: 'Página de producto',
      slot: 0,
      detail: `${producto?.attributes?.nombre} || Producto #${producto?.id}`,
      owner: null,
      filter1: producto?.attributes?.tematica?.data?.attributes?.nombre,
      filter2: producto?.attributes?.tipo?.data?.attributes?.nombre,
      filter3: producto?.attributes?.color?.data?.attributes?.nombre,
    });
  }

  const getFiltersFromUrl = async () => {
    const { mayorista } = Router.query;
    if (mayorista) {
      setIsMayorista(true);
    }
  };

  useEffect(() => {
    if (!Router.isReady) return;
    getFiltersFromUrl();
  }, [Router.isReady]);

  useEffect(() => {
    setMobile(isMobile());
    sendEventToSC();
  }, []);

  useEffect(() => {
    const listaActiva = esMayorista ? carritoMayorista : carrito;
    setShowCartButton(listaActiva.length > 0);
    setCantidadEnCarrito(listaActiva.find((item) => item.producto.id === producto?.id)?.cantidad || 0);
  }, [carrito, carritoMayorista, esMayorista, producto]);

  const handleAgregar = () => {
    if (!producto) return;
    const productoAGuardar = esMayorista ? {
      ...producto,
      attributes: {
        ...producto.attributes,
        precioFinal: precioConDescuentoMayorista(producto.attributes.precioFinal || 0),
      },
    } : producto;
    const agregarProducto = esMayorista ? agregarProductoMayorista : agregarProductoCarrito;
    dispatch(agregarProducto({ cantidad: 1, producto: productoAGuardar }));
  };

  return {
    mobile,
    showCartButton,
    esMayorista,
    cantidadEnCarrito,
    handleAgregar,
  };
};

export default useHook;
